import api from './api';

// Public — used for registration dropdown (returns approved tenants only)
export const getTenants = () => api.get('/api/tenants');

// Platform admin — full detail for one tenant
export const getTenant = (id) => api.get(`/api/tenants/${id}`);

// Authenticated — fetch tenant by slug (admin/staff or active member of that tenant)
export const getTenantBySlug = (slug) => api.get(`/api/tenants/slug/${slug}`);

// Public — self-service tenant onboarding (creates pending tenant)
export const registerTenant = (data) => api.post('/api/tenants/register', data);

// cip_admin only — tenant lifecycle
export const getPendingTenants = () => api.get('/api/tenants/pending');
export const createTenant   = (data)    => api.post('/api/tenants', data);
export const updateTenant   = (id, data) => api.put(`/api/tenants/${id}`, data);
export const approveTenant  = (id)       => api.patch(`/api/tenants/${id}/approve`);
export const suspendTenant  = (id)       => api.patch(`/api/tenants/${id}/suspend`);

// Public — communities that have opted in to be listed in the directory
export const getDirectoryTenants   = ()          => api.get('/api/tenants/directory');

// Community admin — update branding for their own tenant (or cip_admin for any)
export const updateTenantBranding  = (id, data) => api.patch(`/api/tenants/${id}/branding`, data);
export const updateModuleConfig    = (id, data) => api.patch(`/api/tenants/${id}/module-config`, data);
export const updateTenantSettings  = (id, data) => api.patch(`/api/tenants/${id}/settings`, { settings: data });
export const updateCommunityHome = (id, communityHomeText) => api.patch(`/api/tenants/${id}/home-content`, { communityHomeText });
export const getUsers         = (params)              => api.get('/api/users', { params });
export const getUser          = (id)                  => api.get(`/api/users/${id}`);
export const updateUserRole   = (id, globalRole)      => api.patch(`/api/users/${id}/role`, { globalRole });
export const resetUserPassword = (id, newPassword)    => api.patch(`/api/users/${id}/password`, { newPassword });
export const assignUserToTenant = (id, data)          => api.post(`/api/users/${id}/memberships`, data);
export const unassignUserFromTenant = (userId, membershipId) => api.delete(`/api/users/${userId}/memberships/${membershipId}`);
export const deleteUser       = (id)                  => api.delete(`/api/users/${id}`);
export const restoreUser      = (id)                  => api.post(`/api/users/${id}/restore`);
export const checkUserDeletion = (id)                 => api.get(`/api/users/${id}/deletion-check`);
export const permanentlyDeleteUser = (id)             => api.delete(`/api/users/${id}`, { params: { permanent: true } });
export const previewUserPurge  = (id)                  => api.get(`/api/users/${id}/purge-preview`);
export const purgeUser         = (id, data)            => api.post(`/api/users/${id}/purge`, data);
